import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface, VarKey } from "@swivl-mono/types";
import { get } from "http";
import _ from "lodash";

import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import VarsModel from "../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorCondition from "../SidePanel/Inspector/components/InspectorCondition";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const Logic = {
  Type: "logic",
  Empty: function () {
    return {
      id: RandomId(6),
      type: Logic.Type,
      delay: 0,
      showTyping: false,
      value1: "#*User:LastInput*#",
      title: "Last User Input",
      conditions: [
        {
          id: RandomId(6),
          operator: "==",
          value2: "true",
          conditionMetGoto: null,
          firstLine: "==",
          secondLine: "IS SET"
        },
        {
          id: RandomId(6),
          operator: "else",
          value2: "Else",
          conditionMetGoto: null,
          secondLine: "ELSE"
        }
      ]
    };
  },

  PlumbData: function (node: NodeInterface) {
    // let data = {node:node, edges:[]};
    const nodeTitle = VarsModel.nameForVariable(node.value1);

    let tabs: any = [];
    if (node.conditions) {
      for (var i = 0; i < node.conditions.length; i++) {
        let title = "";
        if (node.conditions[i].operator === "else") {
          title = " \nELSE";

          // node.conditions[i].firstLine = "";
          // node.conditions[i].secondLine = "ELSE";
        } else if (node.conditions[i].operator === "isSet") {
          // node.conditions[i].firstLine = "";
          // node.conditions[i].secondLine = "IS SET";

          title = " \nIS SET";
        } else {
          title = node.conditions[i].operator + "\n" + VarsModel.nameForVariable(node.conditions[i].value2);

          // node.conditions[i].firstLine = node.conditions[i].operator;
          // node.conditions[i].secondLine = editor.nameForVariable(node.conditions[i].value2)
        }
        let condition = node.conditions[i];
        tabs.push({
          id: "conditions_" + condition.id,
          source: "conditions_" + i + "_conditionMetGoto",
          target: condition.conditionMetGoto,
          title: title
        });
      }

      return TabNodeLayoutData({
        node: node,
        label: "logic",
        title: nodeTitle,
        baseWidth: 150,
        titleHeight: 40,
        bodyHeight: 0,
        tabs: tabs,
        tabTitleHeight: 40
      });
    }
  },
  InspectorPanel: class LogicInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.onChangeValue1 = this.onChangeValue1.bind(this);
      this.addCondition = this.addCondition.bind(this);
      // this.onVariableChange = this.onVariableChange.bind(this)
    }
    onChangeValue1(event: any) {
      let node = JSON.parse(JSON.stringify(this.props.node));

      console.log("KIEM", event.target.value);

      if (event.target.value === "CHANNEL") {
        node.conditions = [
          {
            id: "SMSCondition",
            operator: "==",
            value2: "SMS",
            conditionMetGoto: null
          },
          {
            id: "WebCondition",
            operator: "==",
            value2: "Web",
            conditionMetGoto: null
          },
          {
            id: "FBMCondition",
            operator: "==",
            value2: "FBM",
            conditionMetGoto: null
          },
          {
            id: "VoiceCondition",
            operator: "==",
            value2: "Voice",
            conditionMetGoto: null
          }
        ];

        node.value1 = "CHANNEL";
        this.props.updateNode(node, this.props.node, true);
      } else if (event.target.value === VarKey.UserLastAMDStatus) {
        // These values are mirrored from VoiceCall.Service.ts (80-88), representing `answeredBy` AMD states and their respective branches
        node.conditions = [
          {
            id: "HumanAMD",
            operator: "==",
            value2: "human",
            conditionMetGoto: null
          },
          {
            id: "MachineStartAMD",
            operator: "==",
            value2: "machine_start",
            conditionMetGoto: null
          },
          {
            id: "MachineEndBeepAMD",
            operator: "==",
            value2: "machine_end_beep",
            conditionMetGoto: null
          },
          {
            id: "MachineEndSilenceAMD",
            operator: "==",
            value2: "machine_end_silence",
            conditionMetGoto: null
          },
          {
            id: "MachineEndOtherAMD",
            operator: "==",
            value2: "machine_end_other",
            conditionMetGoto: null
          },
          {
            id: RandomId(6),
            operator: "else",
            value2: "Else",
            conditionMetGoto: null,
            secondLine: "ELSE"
          }
        ];
        node.value1 = VarKey.UserLastAMDStatus;
        this.props.updateNode(node, this.props.node, true);
      } else if (node.value1 === "CHANNEL") {
        node.conditions = [
          {
            id: RandomId(6),
            operator: "==",
            value2: "true",
            conditionMetGoto: null,
            firstLine: "==",
            secondLine: "IS SET"
          },
          {
            id: RandomId(6),
            operator: "else",
            value2: "Else",
            conditionMetGoto: null,
            secondLine: "ELSE"
          }
        ];
        node.value1 = event.target.value;
        this.props.updateNode(node, this.props.node, true);
      } else {
        this.onChange(event);
      }
    }
    addCondition() {
      let conditionData = {
        id: RandomId(6),
        operator: "==",
        value2: "",
        conditionMetGoto: null
      };
      let node = JSON.parse(JSON.stringify(this.props.node));
      let arr = _.get(node, "conditions");
      if (!arr) {
        arr = [];
      }
      let elseCondition = arr.pop();
      arr.push(conditionData);
      arr.push(elseCondition);
      _.set(node, "conditions", arr);
      this.props.updateNode(node, this.props.node, true);
    }

    // onVariableChange(event:any) {
    //    this.onChange({target:{name:event.target.name, value:"#*" + event.target.value + "*#"}})
    // }
    //

    onDragEnd = (e: any) => {
      if (!e.destination || !e.source || !e.destination.droppableId || !e.source.droppableId || !e.draggableId) {
        return;
      }

      var oldOrder = this.props.node.conditions;
      if (e.destination.index >= oldOrder.length) {
        var k = e.destination.index - oldOrder.length + 1;
        while (k--) {
          oldOrder.push(undefined);
        }
      }
      oldOrder.splice(e.destination.index, 0, oldOrder.splice(e.source.index, 1)[0]);
      let node = JSON.parse(JSON.stringify(this.props.node));
      _.set(node, "conditions", oldOrder);
      this.props.updateNode(node, this.props.node, true);
      return;
    };

    render() {
      let conditionViews: any;

      if (this.props.node.conditions && this.props.node.value1 !== "CHANNEL") {
        conditionViews = this.props.node.conditions.map((item, index) => {
          return (
            <InspectorCondition
              key={item.id}
              condition={item}
              conditions={this.props.node.conditions}
              nodeValue1={this.props.node.value1}
              arrayName="conditions"
              arrayIndex={index}
              onChange={this.onChange}
              deleteValue={this.deleteValue}
              moveItemInArray={this.moveItemInArray}
              name={"conditions." + index + ".operator"}
              val2Name={"conditions." + index + ".value2"}
            />
          );
        });
      }

      return (
        <DragDropContext onDragEnd={this.onDragEnd} onDragStart={(e: any) => {}}>
          <div className="panel logicPanel flex flex-col gap-2">
            <InspectorNodeHeader title="Logic" />
            <div className="valueOneBlock">
              <div className="ifText">IF</div>
              <UserVariablesDropdown
                onChange={this.onChangeValue1}
                skipUserId={false}
                name="value1"
                prependOptions={[{ id: "CHANNEL", value: "CHANNEL", name: "Channel (Web, SMS, FBM, Voice)", label: "Session - Channel" }]}
                value={this.props.node.value1}
                addMarkup
              />
            </div>
            <div className="conditionsList flex flex-col gap-2">
              <Droppable droppableId={"droppable_" + this.props.node.id} type="CONDITION">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={{ backgroundColor: snapshot.isDraggingOver ? "#C3BCB9" : "transparent", borderRadius: 25, padding: "20px 0" }}
                    {...provided.droppableProps}
                  >
                    {provided.placeholder}
                    {conditionViews}
                  </div>
                )}
              </Droppable>
              <div className="addElementButton" onClick={this.addCondition}>
                + ADD CONDITION
              </div>
            </div>

            <InspectorFooter
              deleteNode={this.deleteNode}
              node={this.props.node}
              duplicateNode={this.props.duplicateNode}
              canDuplicate={this.props.canDuplicate}
            />
          </div>
        </DragDropContext>
      );
    }
  }
};
export default Logic;
